class InstalatorRegistrationService {
    constructor($q, ServerConnectorService) {
      this.$q = $q;
      this.serverConnectorService = ServerConnectorService;
    
      this.serverActions = {
        register : 'create_engineer_account',
        activateAccount: 'activate_engineer_account'  
      };
    }
    
    register(form){
      var deferred = this.$q.defer();
      var websocket = this.serverConnectorService.connect();
      var request = {
        action_name : this.serverActions.register,
        first_name : '',
        last_name : '',
        license_id :  form.idNumber.$modelValue,
        password : form.password.$modelValue,
        email :  form.email.$modelValue,
        phone : ''
      }

      this.serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    activateAccount(licenseId, token){
      var deferred = this.$q.defer();
      var websocket = this.serverConnectorService.connect();
      var request = {
        action_name : this.serverActions.activateAccount,
        license_id :  licenseId,
        token : token
      }

      this.serverConnectorService.send(request, websocket, deferred);
      return deferred.promise;
    }

    static factory($q, ServerConnectorService){
        return new InstalatorRegistrationService($q, ServerConnectorService);
    }
}

InstalatorRegistrationService.factory.$inject = ['$q', 'ServerConnectorService'];
export default InstalatorRegistrationService = InstalatorRegistrationService.factory


// WEBPACK FOOTER //
// ./src/service/server-connector/instalator-registration.service.js